export default {
	type: "button",
	url: "",
	onClick: () => null,
};
